import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import Title from "./title";
import { setCheckinPopupOpen } from "../redux/actions/gym/gymAction";
import { ComonIcons } from "../contents/commonIcons";
import DataTable from "react-data-table-component";


export const CheckinPopup = ({ checkinData, setCheckinData }) => {
  const { checkinPopupOpen } = useSelector(state => state.gym);
  const dispatch = useDispatch();
  const toggle = () => {
    dispatch(setCheckinPopupOpen(!checkinPopupOpen))
  }

  const tableColumns = [
    {
      name: `Name`,
      selector: (row) => <span className={`${row.name === 'Unkown member' ? 'text-danger' : ''}`}>
        {row.name}
      </span>
    },
    {
      name: `Package`,
      selector: (row) =>
        <span className={`${!row.success ? 'text-danger' : ''}`}>
          {`${row.success ? row.package : "No Active Package"}`}
        </span>,
    },
    {
      name: `Time`,
      selector: (row) =>
        `${row.time}`,
      sortable: true
    },
    {
      name: `Status`,
      selector: (row) => <span className={`${!row.success ? 'text-danger' : ''}`}>
        {`${row.success ? "Success" : "Failed"}`}
      </span>,
      sortable: true
    },
  ]

  useEffect(() => {
    if (checkinPopupOpen) {
      const viewedData = checkinData.map(itm => ({ ...itm, viewed: true }));
      sessionStorage.setItem('temp-checkin-list', JSON.stringify(viewedData));

      setCheckinData(viewedData);
    }
  }, [checkinPopupOpen])

  return (
    <Modal
      isOpen={checkinPopupOpen}
      centered={true}
      size={"lg"}
      className="large-pop adding-popup"
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title title="Member checkin" />
            </div>
            <div className="d-inline-flex ml-auto">
              <div className="close-icons pb-0">
                <div className="text-right">
                  <span
                    className="svg-block"
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {ComonIcons.closeBlack}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={12}>
              <h3 className="text-danger text-center text-wrap">Check-ins</h3>
              {
                <div className="table-section">
                  <div className="table-main-block">
                    <DataTable columns={tableColumns} data={checkinData} />
                  </div>
                </div>

              }
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  )
}